export function initEmailLinks() {
  document.querySelectorAll('.email-link').forEach(el => {
    const user = el.dataset.user;
    const domain = el.dataset.domain;
    if (!user || !domain) return;

    const address = [user, domain].join(String.fromCharCode(64));
    const a = document.createElement('a');
    a.href = `mailto:${address}`;
    a.textContent = address;

    // clear any fallback and insert the link
    el.innerHTML = '';
    el.appendChild(a);
  });
}
